<template>
    <div class="toolbox-content">
        <h3>In Layer importieren</h3>
        <v-select
                v-model="selectedLayer"
                class="sr-select"
                :items="getLayers"
                :disabled="loading"
                item-value="id"
                item-text="title"
                return-object
        >
            <template #item="{item}">
                <i></i>
                <span>
                                    <simple-svg
                                            :filepath="item.iconUrl"
                                            :fill="item.color"
                                            :stroke="item.stroke"
                                    ></simple-svg>
                                    <div class="layer-title">{{ item.title}}</div>
                    </span>
            </template>
            <template #selection="{item}">
                <i></i>
                <span>
                                    <simple-svg
                                            :filepath="item.iconUrl"
                                            :fill="item.color"
                                            :stroke="item.stroke"
                                    ></simple-svg>
                                    <div class="layer-title">{{ item.title}}</div>
                    </span>
            </template>
        </v-select>
        <fade-loader v-bind="fadeLoader"></fade-loader>
    </div>
</template>

<script>
  import importer from '@/api/importer'
  import FadeLoader from '@/components/base/FadeLoader'

  export default {
    components: { FadeLoader },
    props: {
      value: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selectedLayer: null
      }
    },
    mounted () {
      // reset the model
      this.$resolve()
      if (this.value.alreadyUploaded === true) {
        return
      }

      this.value.filePaths = null
      this.value.fileColumns = null
      this.value.layerColumns = null
    },
    methods: {
      startUpload () {
        this.value.step = 2
        this.$emit('loading', true)
        this.$_fadeLoader_setLoading()
        this.value.getDropzone().on('successmultiple', (success, response) => {
          this.$emit('loading', false)
          this.$_fadeLoader_setComplete()
          this.value.filePaths = response.data.files
          this.value.fileColumns = response.data.fileColumns
          this.value.fileColumnExamples = response.data.examples
          this.value.layerColumns = response.data.layerColumns
          this.value.alreadyUploaded = true
          this.value.step = 3
        })

        this.value.getDropzone().on('error', (file, response) => {
          this.$emit('loading', false)
          this.$_fadeLoader_setComplete()
          this.fadeLoader.errorLoading = true
          this.fadeLoader.errorResponse = response.error

          // remove item from preview
          this.value.getDropzone().removeFile(file)

          // duplicate File objet
          let newFile = new File([file], file.name, { type: file.type })

          this.value.getDropzone().addFile(newFile)
        })

        if (!this.value.fileColumns) {
          this.value.getDropzone().options.params = { layerId: this.selectedLayer.id }
          this.value.getDropzone().processQueue()
        } else {
          // analyze it again
          importer.analyze(this.selectedLayer.id).then((response) => {
            this.$emit('loading', false)
            this.$_fadeLoader_setComplete()
            this.value.layerColumns = response.data.layerColumns
            this.value.step = 3
          }).catch((response) => {
            this.$emit('loading', false)
            this.fadeloader.errorResponse = response
            this.$_fadeLoader_setComplete()
          })
        }
      }
    },
    computed: {
      getLayers () {
        if (this.$store.getters['auth/checkPermissions']('admin')) {
          return this.$store.getters['layer/getAll']
        } else if (this.$store.getters['auth/checkPermissions']('import')) {
          return this.$store.getters['layer/getAll'].filter((layer) => layer.objectsAdoptable)
        }

        return []
      }
    },
    watch: {
      selectedLayer (newVal, oldVal) {
        this.value.selectedLayer = newVal
        if (!oldVal || newVal.id !== oldVal.id) {
          this.startUpload()
        }
      }
    }
  }
</script>

<style scoped>

</style>
